import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage } from '../validation/validationError';
import { adminExamRequestFormValidation } from '../validation/Validation';
import { Loader } from '../components/ModalsCommonFunctions';
import { ZodError } from 'zod';

const AdminExamRequest = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const initialFormState = {
        instituteMasterId: "",
        sectionMasterId: ""
    }

    const [examData, setExamData] = useState(initialFormState);
    const [instituteList, setInstituteList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [requestList, setRequestList] = useState([]);
    const [isRequest, setIsRequest] = useState(false);
    const [error, setError] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getInstituteList();
    }, []);

    const getInstituteList = () => {
        const apiUrlForInstituteList = `/get-institute-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstituteList)
            .then(response => {
                setInstituteList(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            })
    }

    const handleInsituteChange = (e) => {
        const { name, value } = e.target;
        setExamData(prevData => {
            return {
                ...prevData,
                [name]: value,
                sectionMasterId: ''
            }
        })

        getSectionList(value);
    }

    const getSectionList = (instituteMasterId) => {
        const apiUrlForSection = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSection)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setExamData(prevData => {
            return {
                ...prevData,
                [name]: value
            }
        })
        setIsRequest(false);

        if (value.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const getReLoginRequestList = async () => {
        try {
            await adminExamRequestFormValidation.parseAsync(examData);
            setError([]);
            setLoading(true);
            const apiUrl = `/get-student-exam-request?section_id=${examData.sectionMasterId}`;
            const response = await authorizedAxiosSection.get(apiUrl);
            setRequestList(response.data.data)
            setIsRequest(true);
        } catch (error) {
            setRequestList([]);
            if (error instanceof ZodError) {
                setError(error.errors);
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const handleRequest = (id, status) => {
        const apiUrl = `/update-student-exam-request?id=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.patch(apiUrl, { status })
            .then(response => {
                getReLoginRequestList();
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputReset = () => {
        setExamData(initialFormState);
        setRequestList([]);
        setError([]);
        setIsRequest(false);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />

                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Exam Request</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-user-clock"></i> Exam Request</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="instituteMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Institute</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteMasterId' onChange={handleInsituteChange} value={examData.instituteMasterId} >
                                                        <option selected value={''} disabled>Select Institute</option>
                                                        {
                                                            instituteList?.map((institute) => {
                                                                return <option value={institute.id}>{institute.instituteName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="instituteMasterId" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleInputChange} value={examData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="sectionMasterId" />
                                                </div>

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-primary" type="button" onClick={getReLoginRequestList}>Show</button>
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    {isRequest && <div className="separator"></div>}

                                                    {
                                                        isRequest && requestList.length > 0 ?
                                                            requestList.map((request) => (
                                                                <>
                                                                    {(request.status === 1) && (
                                                                        <div className="alert alert-warning alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Pending:</strong> A student named {request.StudentMaster.studentName} has requested to Exam. Do you want to approve?
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div>
                                                                            </div>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-approve-custom mx-1"
                                                                                    aria-label="Approve"
                                                                                    onClick={() => handleRequest(request.id, '2')}
                                                                                >
                                                                                    <i className="fas fa-check"></i>
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-reject-custom mx-1"
                                                                                    aria-label="Reject"
                                                                                    onClick={() => handleRequest(request.id, '3')}
                                                                                >
                                                                                    <i className="fas fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>)}
                                                                    {(request.status === 2) && (
                                                                        <div className="alert alert-success alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Approved:</strong> {request.StudentMaster.studentName} Exam request was approved.
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div>
                                                                            </div>
                                                                        </div>)}
                                                                    {(request.status === 3) && (
                                                                        <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Rejected:</strong> {request.StudentMaster.studentName} Exam request was rejected.
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div>
                                                                            </div>
                                                                        </div>)}
                                                                </>
                                                            ))
                                                            :
                                                            isRequest ? (
                                                                <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                                    <strong>No Request Available</strong>
                                                                </div>
                                                            ) : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AdminExamRequest
